/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Container, Subtitle, ContainerArrow, ContainerArrowRight } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";


const CarouselNavigation = ({ idOperation, children }) => {
  const history = useHistory();
  const loading = useContext(GlobalLoaderContext);
  const fitinsur = new FitinsurAPI();
  const authContext = useContext(GlobalAuthContext);
  const mc = new MessageCenter();
  const [operationsList, setOperationsList] = useState([]);
  const [positionArray, setPositionArray] = useState(null);
  const [isMasterPolicy, setIsMasterPolicy] = useState(false);
  const [isMarketChanges, setIsMarketChanges] = useState(false);
  const [idOperationParent, setIdOperationParent] = useState(null);

  const goToLoginPage = () => {
    history.push('/login');
  };

  async function getOperationInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(idOperation)
      .then(response => response.json())
      .then(response => {
        setIsMasterPolicy(response.isMasterPolicy);
        setIsMarketChanges(response.isMarketChanges && response.idDomain === 26);
        setIdOperationParent(response.idOperationParent);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${getOperationInfo.name}\n` + error);
      });
  }

  async function getDocumentOperations() {
    if (idOperation) {
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestListDocumentOperations(idOperation).then(response => response.json())
        .then(data => {
          if (data.ret_code !== 200) {
            mc.error(data.ret_msg_details);
            return;
          }
          setOperationsList(data.ret_value.operationsList);
        })
    }
  }

  const checkOperationRouteEnquiry = (res) => {
    let route = "";
    const { idOperationParent, idProduct, idOperation, idNavigation } = res.ret_value;
    // eslint-disable-next-line default-case
    switch (idNavigation) {
      case 1:
        route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
        break;
      case 2:
        route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
        break;
      case 3:
        route = `/broking/approval-nbi/${idOperation}`;
        break;
      case 4:
        if (idProduct == "16") {
          route = `/broking/select-markets/${idOperation}/${idProduct}`;
        } else {
          route = `/broking/select-markets/${idOperation}`;
        }
        break;
      case 5:
        route = `/broking/contacts-selection/${idOperation}`;
        break;
      case 6:
        route = `/broking/nbi-request/${idOperation}`;
        break;
      case 7:
        route = `/broking/send-nbi-request/${idOperation}`;
        break;
      case 8:
        route = `/broking/market-selection/${idOperation}`;
        break;
      case 9:
        route = `/broking/document-nbi-status/${idOperation}`;
        break;
      case 10:
        route = `/broking/approval-nbi-cv/${idOperation}`;
        break;
      case 11:
        route = `/broking/nbi-request-cv/${idOperation}`;
        break;
      case 12:
        route = `/broking/market-composition/${idOperation}`;
        break;
      case 13:
        route = `/broking/policy-pack-approval/${idOperation}`;
        break;
      case 14:
        route = `/broking/approval-policy-pack/${idOperation}`;
        break;
      case 15:
        route = `/broking/send-policy-pack-client/${idOperation}`;
        break;
      case 16:
        route = `/broking/send-approval-pack/${idOperation}`;
        break;
      case 17: //result.ret_value = {idNavigation: 17, dscNavigation: "Order to Bind Sent"};
        route = `/broking/send-order-to-bind/${idOperation}`;
        break;
      case 18: //result.ret_value = {idNavigation: 18, dscNavigation: "Order to Bind Approved"};
        route = `/broking/order-to-bind/${idOperation}`;
        break;
      case 19: //result.ret_value = {idNavigation: 19, dscNavigation: "Order to Bind Rejected"};
        route = `/broking/order-to-bind/${idOperation}`;
        break;
      case 20: //result.ret_value = {idNavigation: 20, dscNavigation: "Stamp Requested"};
        route = `/broking/stamps-status-list/${idOperation}`;
        break;
      case 21: //result.ret_value = {idNavigation: 21, dscNavigation: "Stamp Requested"};
        route = `/broking/payment-pack-send-approval/${idOperation}`;
        break;
      case 22: //result.ret_value = {idNavigation: 22, dscNavigation: "Stamp Requested"};
        route = `/broking/payment-pack-send-client-insurer/${idOperation}`;
        break;
      case 23: //result.ret_value = {idNavigation: 23, dscNavigation: "Stamp Requested"};
        route = `/broking/payment-pack-approval/${idOperation}`;
        break;
      case 99:
        route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
        break;
    }

    if (route) {
      loading.stop();
      history.push(
        {
          pathname: route,
          state: res.ret_value.idNavigation == 99 ? { disabled: true, idProduct: idProduct } : { idProduct: idProduct }
        })

      document.location.reload();
    } else {
      mc.error('NAVIGATION NOT DEFINED');
      loading.stop();
    }
  }

  const checkOperationRoute = (idOperation) => {
    fitinsur.setAuthToken(authContext.token);
    loading.start();

    fitinsur.requestPolicyNavigation(idOperation).then(x => x.json()).then(res => {
      loading.stop();

      if (res.ret_code != 200) {
        mc.error(res.ret_msg_details);
        return;
      }

      let { route, idNavigation } = res.ret_value;

      if (idNavigation) return checkOperationRouteEnquiry(res);

      if (route) {
        history.push({ pathname: route })
        document.location.reload();
      } else {
        mc.error('NAVIGATION NOT DEFINED');
        loading.stop();
      }
    }).catch(() => loading.stop());
  }

  useEffect(() => {
    if (operationsList.length) {
      const validatedId = isMarketChanges ? idOperationParent : idOperation;
      const arrayPosition = operationsList.findIndex(operation => operation.idOperation == validatedId);
      setPositionArray(arrayPosition)
    }
  }, [operationsList]);

  useEffect(() => {
    if (authContext.status !== true) {
      mc.error("User is not authenticated, please Login");
      loading.stop();
      goToLoginPage();
      return;
    } else {
      fitinsur.setAuthToken(authContext.token);
      loading.stop();
    };

    if (idOperation) getDocumentOperations();
    getOperationInfo();
  }, []);



  return (
    (idOperation && operationsList) && (
      <Container>
        {(!isMasterPolicy && operationsList[positionArray - 1]) &&
          <ContainerArrow>
            <FontAwesomeIcon
              style={{ cursor: 'pointer' }}
              icon={faAngleLeft}
              size="1x"
              color="gray"
              onClick={() => { checkOperationRoute(operationsList[positionArray - 1].idOperation); }}
            />
          </ContainerArrow>}

        <Subtitle>{operationsList[positionArray]?.referenceNumber || ''}</Subtitle>

        {(!isMasterPolicy && operationsList[positionArray + 1]) &&
          <ContainerArrowRight>
            <FontAwesomeIcon
              style={{ cursor: 'pointer' }}
              icon={faAngleRight}
              size="1x"
              color="gray"
              onClick={() => { checkOperationRoute(operationsList[positionArray + 1].idOperation); }}
            />
          </ContainerArrowRight>}
      </Container>
    )
  )
}

export default CarouselNavigation;
